import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { VolumeCard } from '../VolumeCard';
import { VOLUMES } from '../../data/collection';
export function CollectionSection() {
  return <section id="volumenes" aria-labelledby="volumenes-title" className="w-full bg-ivory" data-id="element-196" data-mp="17ezyzaeremei">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-197" data-mp="12gonywcqa5up">
        <SectionHeading id="volumenes-title" title="Descubrí los 31 modelos de la colección" intro="Seis volúmenes y 31 modelos. Cada volumen incluye su manual de confección y su PDF de moldes, por separado." data-id="element-198" data-mp="203ncukx6i9i1" />

        <div className="mt-10" data-id="element-199" data-mp="1qbhpxplsai9p">
          <Carousel items={VOLUMES} label="Los seis volúmenes" grid="md-2-lg-3" itemClassName="w-[82%] sm:w-[60%]" getKey={volume => String(volume.number)} renderItem={volume => <VolumeCard volume={volume} data-id="element-201" data-mp="2e24y8bzm39ws" />} data-id="element-200" data-mp="1leiu92mh239e" />
        </div>
      </div>
    </section>;
}